import { parseAsArrayOf, parseAsBoolean, parseAsInteger, parseAsString, useQueryState } from 'nuqs'

const CATEGORY_SLUGS = [
  'food-grocery',
  'fashion-traditional-wear',
  'jewelry-accessories',
  'beauty-wellness-personal-care',
  'home-living-decor',
  'arts-crafts-collectibles',
  'gifts-occasions',
]

export function useFilters() {
  const [minPrice, setMinPrice] = useQueryState('price_min', parseAsInteger)
  const [maxPrice, setMaxPrice] = useQueryState('price_max', parseAsInteger)
  const [priceExact, setPriceExact] = useQueryState('price_exact', parseAsInteger)
  const [rating, setRating] = useQueryState('rating', parseAsInteger)
  const [categories, setCategories] = useQueryState('categories', parseAsArrayOf(parseAsString).withDefault([]))
  const [inStock, setInStock] = useQueryState('availability', parseAsBoolean.withDefault(false))
  const [discounted, setDiscounted] = useQueryState('discount', parseAsBoolean.withDefault(false))
  const [sortBy, setSortBy] = useQueryState('ordering', parseAsString)
  const [searchQuery, setSearchQuery] = useQueryState('search', parseAsString.withDefault(''))
  const [slug, setSlug] = useQueryState('slug', parseAsString)
  const [tags, setTags] = useQueryState('tag', parseAsArrayOf(parseAsString).withDefault([]))
  const [type, setType] = useQueryState('type', parseAsString)
  const [page, setPage] = useQueryState('page', parseAsInteger.withDefault(1).withOptions({ shallow: false }))

  const categorySlug = slug && CATEGORY_SLUGS.includes(slug) ? slug : null
  const subcategorySlug = slug && !CATEGORY_SLUGS.includes(slug) ? slug : null

  const clearAll = () => {
    setMinPrice(null)
    setMaxPrice(null)
    setPriceExact(null)
    setRating(null)
    setCategories(null)
    setInStock(null)
    setDiscounted(null)
    setSortBy(null)
    setSearchQuery(null)
    setSlug(null)
    setTags(null)
    setType(null)
    setPage(null)
  }

  return {
    minPrice,
    setMinPrice,
    maxPrice,
    setMaxPrice,
    priceExact,
    setPriceExact,
    rating,
    setRating,
    categories,
    setCategories,
    inStock,
    setInStock,
    discounted,
    setDiscounted,
    sortBy,
    setSortBy,
    searchQuery,
    setSearchQuery,
    slug,
    setSlug,
    categorySlug,
    setCategorySlug: setSlug,
    subcategorySlug,
    setSubcategorySlug: setSlug,
    type,
    setType,
    tags,
    setTags,
    page,
    setPage,
    clearAll,
  }
}
